import "bootstrap";
import 'fotorama/fotorama';
//import 'fotorama/fotorama.css';

class MyGallery extends React.Component {
    render() {          
        return (
            <div className="fotorama"                
                data-width="100%"
                data-allowfullscreen="true"
                data-keyboard="true"
                data-nav="thumbs"
                navposition="bottom"
            >
                <a href="/images/color/gallery_01_smaller.jpg" data-thumb="/images/color/gallery_01_thumbnail.jpg" />
                <a href="/images/color/gallery_02_smaller.jpg" data-thumb="/images/color/gallery_02_thumbnail.jpg" />
                <a href="/images/color/gallery_03_smaller.jpg" data-thumb="/images/color/gallery_03_thumbnail.jpg" />
                <a href="/images/color/gallery_04_smaller.jpg" data-thumb="/images/color/gallery_04_thumbnail.jpg" />
                <a href="/images/color/gallery_05_smaller.jpg" data-thumb="/images/color/gallery_05_thumbnail.jpg" />
                <a href="/images/color/gallery_14_smaller.jpg" data-thumb="/images/color/gallery_14_thumbnail.jpg" />
                <a href="/images/color/gallery_15_smaller.jpg" data-thumb="/images/color/gallery_15_thumbnail.jpg" />
                <a href="/images/color/gallery_16_smaller.jpg" data-thumb="/images/color/gallery_16_thumbnail.jpg" />
                <a href="/images/color/gallery_17_smaller.jpg" data-thumb="/images/color/gallery_17_thumbnail.jpg" />
                <a href="/images/color/gallery_06_smaller.jpg" data-thumb="/images/color/gallery_06_thumbnail.jpg" />
                <a href="/images/color/gallery_07_smaller.jpg" data-thumb="/images/color/gallery_07_thumbnail.jpg" />
                <a href="/images/color/gallery_08_smaller.jpg" data-thumb="/images/color/gallery_08_thumbnail.jpg" />
                <a href="/images/color/gallery_09_smaller.jpg" data-thumb="/images/color/gallery_09_thumbnail.jpg" />
                <a href="/images/color/gallery_10_smaller.jpg" data-thumb="/images/color/gallery_10_thumbnail.jpg" />
                <a href="/images/color/gallery_11_smaller.jpg" data-thumb="/images/color/gallery_11_thumbnail.jpg" />
                <a href="/images/color/gallery_12_smaller.jpg" data-thumb="/images/color/gallery_12_thumbnail.jpg" />
                <a href="/images/color/gallery_13_smaller.jpg" data-thumb="/images/color/gallery_13_thumbnail.jpg" />                
            </div>
      
        );
    }
}

ReactDOM.render(<MyGallery />, document.getElementById('galleryContainer'));